import "./column-components.298cc9f3.js";
import $kduwi$macrostrathyper from "@macrostrat/hyper";
import {useContext as $kduwi$useContext} from "react";
import $kduwi$classnames from "classnames";
import $kduwi$uibox from "ui-box";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $4a0ea9dcf1a07b76$exports = {};

$parcel$export($4a0ea9dcf1a07b76$exports, "ColumnBox", () => $4a0ea9dcf1a07b76$export$32a0ad71237b9760);
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ 


var $aVUB5 = parcelRequire("aVUB5");


function $4a0ea9dcf1a07b76$export$32a0ad71237b9760(props) {
    const { offsetTop: offsetTop, absolutePosition: absolutePosition, className: className, ...rest } = props;
    const { pixelsPerMeter: pixelsPerMeter, zoom: zoom } = (0, $kduwi$useContext)((0, $aVUB5.ColumnContext));
    const marginTop = offsetTop * pixelsPerMeter * zoom;
    let pos = {
        marginTop: marginTop
    };
    if (absolutePosition) pos = {
        position: "absolute",
        top: marginTop
    };
    return (0, $kduwi$macrostrathyper)((0, $kduwi$uibox), {
        className: (0, $kduwi$classnames)("column-box", className),
        ...pos,
        ...rest
    });
}


export {$4a0ea9dcf1a07b76$export$32a0ad71237b9760 as ColumnBox};
//# sourceMappingURL=column-components.732a45eb.js.map
